"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Footer_1 = __importDefault(require("../../footer/Footer"));
var content_1 = __importDefault(require("./content"));
var Events_1 = __importDefault(require("./Events"));
var Digital_1 = __importDefault(require("./Digital"));
var PrivateMemberships_1 = __importDefault(require("./PrivateMemberships"));
var Music_1 = __importDefault(require("./Music"));
function Collectibles() {
    var pages = ["private-memberships", "events", "digital", "music"];
    var param = window.location.pathname.split("/")[2];
    var pageCheck = pages.find(function (x) { return x === param; });
    var showPage = function () {
        switch (param) {
            case "events":
                return (0, jsx_runtime_1.jsx)(Events_1.default, {});
            case "private-memberships":
                return (0, jsx_runtime_1.jsx)(PrivateMemberships_1.default, {});
            case "digital":
                return (0, jsx_runtime_1.jsx)(Digital_1.default, {});
            case "music":
                return (0, jsx_runtime_1.jsx)(Music_1.default, {});
            default:
                return (0, jsx_runtime_1.jsx)(content_1.default, {});
        }
    };
    return ((0, jsx_runtime_1.jsx)("main", __assign({ className: "homepage HomePageFull" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "home" }, { children: pageCheck ? showPage() : (0, jsx_runtime_1.jsx)(content_1.default, {}) })) })));
}
exports.default = Collectibles;
